module.exports = "./assets/fonts/Lato-Regular.woff";